import React, { Component } from 'react';
import Quote from './Quote';

class Quotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error:null,
      isLoaded:false,
      pubs_from_ids: {}
    };
  }
  
  componentDidMount() {
    const info = this.props.info;
    
    let ids = [];
    for (let i=0;i<info.length;i++) {
      if (Object.keys(info[i]).includes("pubmed_id")) {
        ids.push(info[i]["pubmed_id"]);
      }
    }
    
    if (ids.length > 0) {
      let url = "https://moreygenetics.com/api/read_publications.py?ids="+ids.join(",");
      console.log(url);
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            //console.log(result);
            this.setState({
              isLoaded: true,
              pubs_from_ids: result
            });
          },
          (error) => {
            this.setState({
              isLoaded:true,
              error
            });
          }
        )
    }
  }
  
  render() {
    const { error, isLoaded, pubs_from_ids } = this.state;

    let quote_list = [];
    for (let i=0;i<this.props.info.length;i++) {
      let quote_info = this.props.info[i];
      if (Object.keys(quote_info).includes("pubmed_id")) {
        if (isLoaded===true) {
          Object.assign(
            quote_info,
            pubs_from_ids[quote_info["pubmed_id"]]
          );
          quote_list.push(
            <Quote info={quote_info}/>
          );
        }
      } else {
        quote_list.push(
          <Quote info={quote_info}/>
        );
      }
    }

    return (
      quote_list
    )
  }
}
  
export default Quotes;